module.exports = __webpack_public_path__ + "img/logo.2463ebc0.png";